/** @format */

import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, PLATFORM_ID, Input } from '@angular/core';

@Directive({
    selector: '[homeUtilsAppRunScripts]',
    standalone: false
})
export class RunScriptsDirective implements AfterViewInit {
	@Input() tagSectionNum: any;
	//eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('attr.data-sectionnum') srcAttr: string;

	constructor(
		private elementRef: ElementRef,
		@Inject(PLATFORM_ID) private platformId: any
	) {}

	ngAfterViewInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.reinsertScripts();
		}
	}

	reinsertScripts(): void {
		const scripts = this.elementRef.nativeElement.getElementsByTagName(
			'script'
		) as HTMLScriptElement[];
		const scriptsInitialLength = scripts.length;
		for (let i = 0; i < scriptsInitialLength; i++) {
			if (
				window.document.getElementById(`iliad-replacement-script-${this.srcAttr}-${i}`) ===
				null
			) {
				const script = scripts[i];
				// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
				const scriptCopy = document.createElement('script') as HTMLScriptElement;
				scriptCopy.id = script.id || `iliad-replacement-script-${this.srcAttr}-${i}`;
				scriptCopy.type =
					script.type && script.type !== 'iliad/blocked'
						? script.type
						: 'application/javascript';
				if (script.src) {
					scriptCopy.src = script.src;
				} else if (script.innerHTML) {
					scriptCopy.innerHTML = script.innerHTML;
				}
				scriptCopy.async = false;
				script.parentNode.replaceChild(scriptCopy, script);
			}
		}
	}
}